import config from "../config/default";
import { useCurrentURL } from "../hooks/ContextualNavigations";
import { selectApplication } from "../utils/selectApplication";
import { resolveBrand, hasDedicatedBrandDomain } from "./brandRegistry";
import { selectScreen, ScreenVariant } from "./selectScreen";
import { useAccessContext } from "./useAccessContext";
import { BrandConfig } from "./types";

export interface ScreenSelection {
  variant: ScreenVariant;
  brand: BrandConfig;
}

// Hook único de seleção de variante por rota. O AccessContext (normalizado) alimenta
// resolveBrand/selectScreen; o selectApplication recebe o url BRUTO de useCurrentURL — em
// paridade exata com CurrentApplication (que também usa o url bruto). Passar o urlHost
// normalizado divergiria quando o url vem sem esquema (urlHost indefinido → cairia no
// Default em vez de NotPortal). BRANDED é o único acréscimo no fluxo Default.
export function useScreenVariant(): ScreenSelection {
  const ctx = useAccessContext();
  const params = useCurrentURL();

  const variant = selectScreen(ctx, () =>
    selectApplication(
      { url: params.url, rules: params.rules },
      config.isIDP,
      hasDedicatedBrandDomain(ctx.host)
    )
  );

  return { variant, brand: resolveBrand(ctx) };
}
